export interface ResponsableFacsimile {
    nombre: string;
    cuil: string;
    matricula: string;
    dni: string;
    cargo: string;
    telefono: string;
    email: string;
}

export type FacsimileOrganismoKey = 'cpe' | 'tribunal';

// Los ids de organismo cambian segun el ambiente. CPE: 2322 en test, 3064 en preprod/prod.
export const CPE_ORGANISMO_IDS = [3, 2322, 3064];

export const CPE_RESPONSABLE_FACSIMILE: ResponsableFacsimile = {
    nombre: 'Lorena Alejandra Pacheco',
    cuil: '27-32544877-1',
    matricula: 'PA0666',
    dni: '32544877',
    cargo: 'Responsable del Servicio de Seguridad e Higiene del Consejo Provincial de Educación',
    telefono: '2996084255',
    email: 'lapacheco@neuquen.gov.ar'
} as const;

export const TRIBUNAL_ORGANISMO_IDS = [59];

export const TRIBUNAL_RESPONSABLE_FACSIMILE: ResponsableFacsimile = {
    nombre: 'Pablo Leonardo Ferraris',
    cuil: '20-20935263-0',
    matricula: 'PA0829',
    dni: '20935263',
    cargo: 'Lic. en Higiene y Seguridad',
    telefono: '2995501484',
    email: 'pablo.ferraris@jusneuquen.gov.ar'
} as const;

export const RESPONSABLE_FACSIMILES_BY_ORGANISMO: Record<
    FacsimileOrganismoKey,
    ResponsableFacsimile
> = {
    cpe: CPE_RESPONSABLE_FACSIMILE,
    tribunal: TRIBUNAL_RESPONSABLE_FACSIMILE
};

export const isCpeOrganismo = (organismoId?: number | null) =>
    organismoId != null && (CPE_ORGANISMO_IDS as number[]).includes(organismoId);

export const isTribunalOrganismo = (organismoId?: number | null) =>
    organismoId != null && (TRIBUNAL_ORGANISMO_IDS as number[]).includes(organismoId);

// Identifica cual de los organismos con firma facsimil (si alguno) corresponde a este id, para
// saber que datos/imagen precargar. Se agregan casos nuevos aca (id + facsimil), no tocando
// el resto del flujo de ejecucion de visita, que ya trabaja de forma generica con la clave.
export const getFacsimileOrganismoKey = (
    organismoId?: number | null
): FacsimileOrganismoKey | null => {
    if (isCpeOrganismo(organismoId)) return 'cpe';
    if (isTribunalOrganismo(organismoId)) return 'tribunal';
    return null;
};

export const getResponsableFacsimile = (
    organismoId?: number | null
): ResponsableFacsimile | null => {
    const key = getFacsimileOrganismoKey(organismoId);
    return key ? RESPONSABLE_FACSIMILES_BY_ORGANISMO[key] : null;
};
